<modal class="progress-dialog" [name]="localStorageKeys.ti_modal_progress" [minWidth]="450" [maxWidth]="maxWidth">
<!--  <modal-header>
    <span class="title"></span>
  </modal-header>-->
  <modal-body>
    <label *ngIf="title" for="progress-bar" class="mb-2">{{title}}</label>
    <ti-progress-bar id="progress-bar" color="#1972AA" [isIndeterminate]="isIndeterminate"></ti-progress-bar>
  </modal-body>
<!--  <modal-actions>

  </modal-actions>-->
</modal>
